export default __webpack_public_path__ + "static/media/FRANK OCEAN - CLOSE TO YOU (DRUMBREAK).d70db694.wav";